import { create } from 'zustand'
import { KeyCtrlMenuState } from './KeyCtrlMenuState'
import { Key } from '../../Data/HexMap/Key'
import { Coordinates } from '../../Util/Math/Coordinates'
export interface KeyCtrlMenuConfig{
    key:Key|null,
    coordinates:Coordinates
    setMap:Function
}
export const useKeyCtrlMenuStore = create<KeyCtrlMenuState>()(
  (setter) => new KeyCtrlMenuState(setter)
)

export function useCtrlKey(){
    const key:Key|null = useKeyCtrlMenuStore((state:KeyCtrlMenuState)=>{
      return state.key
    }) 
    return key
}

export function useKeyCtrlMenuCoordinates(){
    const coordinates:Coordinates = useKeyCtrlMenuStore((state:KeyCtrlMenuState)=>{
      return state.coordinates
    }) 
    return coordinates
}
export function useKeyCtrlMenuSetMap(){
    const setMap:Function = useKeyCtrlMenuStore((state:KeyCtrlMenuState)=>{
      return state.setMap
    }) 
    return setMap
}
export function useKeyCtrlMenuIsOpen(){
    const open:boolean = useKeyCtrlMenuStore((state:KeyCtrlMenuState)=>{
      return state.isOpen
    }) 
    return open
}